module.exports = __webpack_public_path__ + "static/media/shopee-logo.11a72c63.jpg";